import styled from 'styled-components';
import { Type } from 'discover.medical.react-component-library';

export const StyledType = styled(Type)`
  vertical-align: super;
  margin-right: 1rem;
`;
